import { jsx as _jsx } from "react/jsx-runtime";
import { Spinner } from '#pplx/frontend/aether/components/Spinner/index.js';
import React from 'react';
export const ModalLoader = React.memo(function ModalLoader() {
    return (_jsx("div", { className: "bg-backdrop fixed inset-0 z-[999] flex items-center justify-center backdrop-blur-xs", children: _jsx(Spinner, {}) }));
});
//# sourceMappingURL=ModalLoader.js.map